import { render, staticRenderFns } from "./_adapter.vue?vue&type=template&id=158ed7b8"
import script from "./_adapter.vue?vue&type=script&lang=js"
export * from "./_adapter.vue?vue&type=script&lang=js"
import style0 from "./_adapter.vue?vue&type=style&index=0&id=158ed7b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports